import axios from "axios";
import Swal from "sweetalert2";

// const BASE_URL = process.env.REACT_APP_API_URL || "https://cradleai.net/cradleAdmin/";
 const BASE_URL = process.env.REACT_APP_API_URL || "https://cradleai.net/cradleAdmin/";

export const Image_Url =
  "https://cradleaibucket.s3.us-east-1.amazonaws.com/users-profile-images/";

export const Local_Image_Url = "https://cradleai.net/assets/images/users/";

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const message = error.response.data?.message;

      if (message === "Session terminated by administrator") {
        Swal.fire({
          title: "Session Terminated",
          text: "Your session has been terminated by an administrator. You will be redirected to the login page.",
          icon: "warning",
          confirmButtonColor: "#0b5fb6",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        }).then(() => {
          localStorage.removeItem("token");
          window.location.href = "/auth/login";
        });
      } else {
        const currentPath = window.location.pathname;
        if (
          currentPath !== "/auth/login" &&
          currentPath !== "/auth/verify-2fa-otp"
        ) {
          localStorage.removeItem("token");
          window.location.href = "/auth/login";
        }
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
